const styles = theme => ({
  root: {
    position: 'relative',
    display: 'block',
    border: 'none',
    margin: 0,
    padding: 0,
    boxShadow: 'none',
    textShadow: 'none'
  },
  link: {
    display: 'block',
    border: 'none',
    outline: 'none',
    userSelect: 'none',
    textAlign: 'center'
  },
  wordmark: {
    display: 'block',
    margin: [0, 'auto'],
    border: 'none',
    padding: 0,
    width: '100%',
    maxWidth: 820,
    opacity: 0,
    filter: `drop-shadow(0 0 6px ${theme.color.secondary.main})`,
    transition: `filter ${theme.animation.time}ms ease-out`
  },
  wordmarkText: {
    fontFamily: `Camiro, ${theme.typography.primary}`,
    fontSize: 116,
    fontWeight: 400,
    fill: theme.color.heading.main,
    stroke: theme.color.secondary.dark,
    strokeWidth: 0.6,
    paintOrder: 'stroke',
    transition: `stroke ${theme.animation.time}ms ease-out, fill ${theme.animation.time}ms ease-out`
  },
  hover: {
    '&:hover': {
      '& $wordmark': {
        filter: `drop-shadow(0 0 14px ${theme.color.secondary.main})`
      },
      '& $wordmarkText': {
        fill: theme.color.secondary.light,
        stroke: theme.color.secondary.main
      }
    }
  }
});

export { styles };
